import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { OddsFormatterPipe } from '@frontend/sports/odds/feature';

import BetslipBaseModule from '../../base/betslip-base.module';
import { NotificationsModule } from '../notifications/module';
import { BetslipBarComponent } from './components/betslip-bar.component';
import { BetslipBarRemovePickService } from './services/betslip-bar-remove-pick.service';
import { BetslipBarReturnsMessageService } from './services/betslip-bar-returns-message.service';
import { BetslipBarTrackingService } from './services/betslip-bar-tracking.service';
import { BetslipBarService } from './services/betslip-bar.service';

@NgModule({
    declarations: [BetslipBarComponent],
    exports: [BetslipBarComponent],
    imports: [CommonModule, BetslipBaseModule, NotificationsModule, TrustPipe, OddsFormatterPipe],
    providers: [BetslipBarService, BetslipBarReturnsMessageService, BetslipBarTrackingService, BetslipBarRemovePickService],
})
export class BetslipBarModule {}
